import {action, makeObservable, observable, runInAction} from "mobx";
import {HomeFeaturedModel} from "@home/components/HomeComponent/Featured";
import {notification} from "antd";
import {request} from "@/framework/network/request";
import Product from "@home/model/Product";
// import {HomePromoteModel} from "@home/components/HomeComponent/HomePromote";
import {BaseProductModel} from "@/components/ProductList/BaseProductList";


export default class ShoppingIndexStore {
  loading: boolean
  carouselBigData: BaseProductModel[] // 首页大轮播图数据
  carouselRowData: BaseProductModel[] // 首页三层轮播图数据
  featuredData: HomeFeaturedModel //精选优品
  // promoteData1: HomePromoteModel //首页促销栏1
  // promoteData2: HomePromoteModel //首页促销栏2
  // promoteData3: HomePromoteModel //首页促销栏3
  // promoteData4: HomePromoteModel //首页促销栏4
  // promoteData5: HomePromoteModel //首页促销栏5
  // promoteData6: HomePromoteModel //首页促销栏6

  constructor() {
    makeObservable(this, {
      loading: observable,
      carouselBigData: observable,
      carouselRowData: observable,
      featuredData: observable,
      // promoteData1: observable,
      // promoteData2: observable,
      // promoteData3: observable,
      // promoteData4: observable,
      // promoteData5: observable,
      // promoteData6: observable,

      getCarouselBigData: action,
      getCarouselRowData: action,
      getFeaturedData: action,
      // getPromoteData1: action,
      // getPromoteData2: action,
      // getPromoteData3: action,
      // getPromoteData4: action,
      // getPromoteData5: action,
      // getPromoteData6: action,

    })
    this.loading = false;
    this.carouselBigData = [];
    this.carouselRowData = []
    this.featuredData = {};
    // this.promoteData1 = {};
    // this.promoteData2 = {};
    // this.promoteData3 = {};
    // this.promoteData4 = {};
    // this.promoteData5 = {};
    // this.promoteData6 = {};
  }


  // 首页大轮播图数据
  getCarouselBigData = async (categoryId: string, size: number) => {
    try {
      this.loading = true
      // const res = await request.get(`/public/products`, {categoryId, size})
      runInAction(() => {
        this.carouselBigData = [
          {
            id: "1001",
            // title: '',
            // price: 41.99,
            // originalPrice: 79,
            // quantity: 134,
            // other: '82天最低价',
            titleFile: '619967389886316544.png'
          },
          {
            id: "1002",
            title: '',
            price: 41.99,
            originalPrice: 79,
            quantity: 134,
            other: '82天最低价',
            titleFile: '619966570239623168.png'
          },
          {
            id: "1003",
            title: '',
            price: 41.99,
            originalPrice: 79,
            quantity: 134,
            other: '82天最低价',
            titleFile: '619967406294433792.png'
          },
        ]
        this.loading = false
      })
    }catch (e) {
      this.loading = false
      notification.error({
        message: '获取精选优品信息错误',
        description: e.message
      })
    }
  }

  // 获取首页三层轮播图数据
  getCarouselRowData = async (categoryId: string, size: number) => {
    try {
      this.loading = true
      // const res = await request.get(`/public/products`, {categoryId, size})
      runInAction(() => {
        this.carouselRowData = [
          {id: "1001",title: '资生堂美容液发膜230g*1' ,price: 41.99,  originalPrice: 79, quantity: 134, other: '82天最低价', titleFile: '503146628299882496.jpg'},
          {id: "1002",title: '资生堂美容液发膜230g*1' ,price: 41.99,  originalPrice: 79, quantity: 134, other: '82天最低价', titleFile: '503147054139179008.jpg'},
          {id: "1003",title: '资生堂美容液发膜230g*1' ,price: 41.99,  originalPrice: 79, quantity: 134, other: '82天最低价', titleFile: '503147627378900992.jpg'},
          {id: "1004",title: '资生堂美容液发膜230g*1' ,price: 41.99,  originalPrice: 79, quantity: 134, other: '82天最低价', titleFile: '503148780997050368.jpg'},
          {id: "1005",title: '资生堂美容液发膜230g*1' ,price: 41.99,  originalPrice: 79, quantity: 134, other: '82天最低价', titleFile: '503149069179289600.jpg'},
          {id: "1006",title: '资生堂美容液发膜230g*1' ,price: 41.99,  originalPrice: 79, quantity: 134, other: '82天最低价', titleFile: '503149781091090432.jpg'},
        ]
        this.loading = false
      })
    }catch (e) {
      this.loading = false
      notification.error({
        message: '获取精选优品信息错误',
        description: e.message
      })
    }
  }

  // 获取精选优品
  getFeaturedData = async (categoryId: string, size: number) => {
    try {
      this.loading = true
      const res = await request.get(`/public/products`, {categoryId, size})
      runInAction(() => {
        this.featuredData.leftFile = "503156453721243648.png"
        this.featuredData.rightFile = "503156474873118720.jpg"
        this.featuredData.carouselData = res.data?.content?.map((item: Product) => {
          const priceList= item.price?.split("-")
          return {
            id: item.id,
            title: item.name,
            price: item.minPrice,
            originalPrice: (priceList?.length && priceList?.length > 1) ? Number(priceList[1].substr(1)) : 0,
            titleFile: item.picture,
          }
        })

        this.loading = false
      })
    } catch (e) {
      this.loading = false
      // notification.error({
      //   message: '获取精选优品信息错误',
      //   description: e.message
      // })
    }
  }

  // // 获取首页促销栏1
  // getPromoteData1 = async (categoryId: string, size: number) => {
  //   try {
  //     this.loading = true
  //     const res = await request.get(`/public/products`, {categoryId, size})
  //     runInAction(() => {
  //       this.promoteData1.themeName = '羊楼洞'
  //       this.promoteData1.themeDescription = '（ YANG LOU DONG ）'
  //       this.promoteData1.file = "510128022125281280.jpg"
  //       this.promoteData1.colData = res.data?.content?.map((item: Product) => {
  //         return {
  //           id: item.id,
  //           title: item.name,
  //           price: item.minPrice,
  //           titleFile: item.picture,
  //         }
  //       })
  //
  //       this.loading = false
  //     })
  //   }catch (e) {
  //     this.loading = false
  //     notification.error({
  //       message: '获取 羊楼洞（YANGLOUDONG）信息错误',
  //       description: e.message
  //     })
  //   }
  // }
  //
  // // 获取首页促销栏2
  // getPromoteData2 = async (categoryId: string, size: number) => {
  //   try {
  //     this.loading = true
  //     const res = await request.get(`/public/products`, {categoryId, size})
  //     runInAction(() => {
  //       this.promoteData2.themeName = '赵李桥茶厂'
  //       this.promoteData2.themeDescription = '（ ZHAO LI QIAO CHA CHANG ）'
  //       this.promoteData2.file = "510127985324457984.jpg"
  //       this.promoteData2.colData = res.data?.content?.map((item: Product) => {
  //         return {
  //           id: item.id,
  //           title: item.name,
  //           price: item.minPrice,
  //           titleFile: item.picture,
  //         }
  //       })
  //
  //       this.loading = false
  //     })
  //   }catch (e) {
  //     this.loading = false
  //     notification.error({
  //       message: '获取 赵李桥（ZHAOLIQIAO）信息错误',
  //       description: e.message
  //     })
  //   }
  // }
  //
  // // 获取首页促销栏3
  // getPromoteData3 = async (categoryId: string, size: number) => {
  //   try {
  //     this.loading = true
  //     const res = await request.get(`/public/products`, {categoryId, size})
  //     runInAction(() => {
  //       this.promoteData3.themeName = '洞庄'
  //       this.promoteData3.themeDescription = '（ DONG ZHUANG ）'
  //       this.promoteData3.file = "505681543390298112.png"
  //       this.promoteData3.colData = res.data?.content?.map((item: Product) => {
  //         return {
  //           id: item.id,
  //           title: item.name,
  //           price: item.minPrice,
  //           titleFile: item.picture,
  //         }
  //       })
  //
  //       this.loading = false
  //     })
  //   }catch (e) {
  //     this.loading = false
  //     notification.error({
  //       message: '获取 洞庄（DONGZHUANG）信息错误',
  //       description: e.message
  //     })
  //   }
  // }
  //
  // // // 获取首页促销栏4
  // getPromoteData4 = async (categoryId: string, size: number) => {
  //   try {
  //     this.loading = true
  //     const res = await request.get(`/public/products`, {categoryId, size})
  //     runInAction(() => {
  //       this.promoteData4.themeName = '赵李桥茶业'
  //       this.promoteData4.themeDescription = '（ ZHAO LI QIAO CHA YE ）'
  //       this.promoteData4.file = "511501585944150016.jpg"
  //       this.promoteData4.colData = res.data?.content?.map((item: Product) => {
  //         return {
  //           id: item.id,
  //           title: item.name,
  //           price: item.minPrice,
  //           titleFile: item.picture,
  //         }
  //       })
  //
  //       this.loading = false
  //     })
  //   }catch (e) {
  //     this.loading = false
  //     notification.error({
  //       message: '获取首页促销栏4信息错误',
  //       description: e.message
  //     })
  //   }
  // }
  //
  // // 获取首页促销栏
  // getPromoteData5 = async (categoryId: string, size: number) => {
  //   try {
  //     this.loading = true
  //     const res = await request.get(`/public/products`, {categoryId, size})
  //     runInAction(() => {
  //       this.promoteData5.themeName = '大德和'
  //       this.promoteData5.themeDescription = '（ DA DE HE ）'
  //       this.promoteData5.file = "506050792399044608.png"
  //       this.promoteData5.colData = res.data?.content?.map((item: Product) => {
  //         return {
  //           id: item.id,
  //           title: item.name,
  //           price: item.minPrice,
  //           titleFile: item.picture,
  //         }
  //       })
  //
  //       this.loading = false
  //     })
  //   }catch (e) {
  //     this.loading = false
  //     notification.error({
  //       message: '获取首页促销栏4信息错误',
  //       description: e.message
  //     })
  //   }
  // }
  //
  // // 获取首页促销栏
  // getPromoteData6 = async (categoryId: string, size: number) => {
  //   try {
  //     this.loading = true
  //     const res = await request.get(`/public/products`, {categoryId, size})
  //     runInAction(() => {
  //       this.promoteData6.themeName = '思贝林'
  //       this.promoteData6.themeDescription = '（ SI BEI LIN ）'
  //       this.promoteData6.file = "510883316623212544.jpg"
  //       this.promoteData6.colData = res.data?.content?.map((item: Product) => {
  //         return {
  //           id: item.id,
  //           title: item.name,
  //           price: item.minPrice,
  //           titleFile: item.picture,
  //         }
  //       })
  //
  //       this.loading = false
  //     })
  //   }catch (e) {
  //     this.loading = false
  //     notification.error({
  //       message: '获取首页促销栏4信息错误',
  //       description: e.message
  //     })
  //   }
  // }

}